<template>
  <div class="context--item--wrapper" v-closable="{ exclude: ['ContextItemLabels'], isClosable: true, handler: 'handleCancel'}">
    <div
      :ref= "'ContextItemLabels'"
      class="context--item--labels--wrapper"
      :class="{'hovered': isEditing, 'hover': hover && isEditable}"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
    <div @[eventName]="handleGlobalEditing" class="context--item--labels--container" :class="[{'editing': isEditing}]">
      <div
      v-if="icon !== null && !isLoading"
      class="icon"
      :class="{'empty--labels':localLabels.length < 1}"
      >
        <v-tooltip left :disabled="iconTooltip === null">
          <template v-slot:activator="{ on }">
            <component :class="[$vuetify.breakpoint.xlOnly ? 'icon-xl' : 'icon-lg-down', 'wrld_black--text']"  v-if="featherIcon != null" :is="featherIcon" />
            <v-icon v-else v-on="on" :color="iconColor" :class="$vuetify.breakpoint.xlOnly ? 'icon-xl' : 'icon-lg-down'">{{ icon }}</v-icon>
          </template>
          <span>{{ iconTooltip }}</span>
        </v-tooltip>
      </div>
      <div class="context--label__items">
      <template v-for="(label, index) in localLabels">
          <div :key="index" v-show="!label.isDeleted" :style="{backgroundColor: (label.color ? label.color : '#767676')}">
            <span
            :style="`color: ${label.textColor};`"
            class="label--name"
            >
              {{translate != null ? $t(`${translate}.${label.name}`) : label.name}}
            </span>
            <span v-show="isEditing" @click="removeLabel(index)" class="label--delete">
              <i class="fa fa-times"></i>
            </span>
          </div>
      </template>
      <div class="empty--labels wrld_black--text" :class="[$vuetify.breakpoint.xlOnly ? 'text-xl' : 'text-lg-down']" v-show="labels.length < 1 && !isEditing">
        {{ emptyLabel }}
      </div>
      <div class="context--label--edit__wrapper" v-show="isEditing" style="position: relative;">
          <input class="context--label--edit__input" type="text" @keyup.enter="addNewLabel(newLabel)" v-model="newLabel" @input="searchInAvailableLabels" :ref="labelEditableID"/>
      </div>
    </div>
    </div>
    <div v-show="(hover || isEditing) && isEditable" class="actions--panel">
        <div class="icon-action" v-for="(action, index) in actions" :key="'action-' + index">
          <v-tooltip top :disabled="action.tooltip === undefined || action.tooltip === ''">
            <template v-slot:activator="{ on }">
              <v-icon v-if="action !== null" v-on="on" @click="action.callback" size="18">{{action.icon}}</v-icon> <!-- dependence on Vuetify   -->
            </template>
            <span>{{ action.tooltip }}</span>
          </v-tooltip>
        </div>
      </div>
      <div v-show="isEditing && labelsAvailableList.length > 0" :ref="'wrld_labels_list'" :class="[{'bottom': bottom}, `list--height--${labelsAvailableList.length}`]" :style="{top: this.labelsItemHeight}" class="labels--list">
        <ul>
          <template v-for="({ text }, index) in labelsAvailableList">
            <li @click="handleSelect(text)" :key="index">{{ translate != null ? $t(`${translate}.${text}`) : text }}</li>
          </template>
        </ul>
      </div>
  </div>
  </div>
</template>

<script>
import { algoliaService } from '@/_services'
import { uuid } from 'vue-uuid'
export default {
  name: 'ContextItemLabels',
  props: {
    isEditable: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    iconTooltip: { type: String, default: null },
    icon: { type: String, default: 'fas fa-tag' },
    iconColor: { type: String, default: null },
    eventName: { type: String, default: null },
    bottom: { type: Boolean, default: false },
    labels: { type: Array, default: () => null },
    emptyLabel: { type: String, default: function () { return this.$i18n.t('general.add_labels') } },
    algoliaSearchLabels: { type: Object, default: () => null },
    allowCustomLabels: {type: Boolean, default: true},
    labelsList: { type: Array, default: () => null },
    translate: { type: String, default: null },
    featherIcon: { type: String, default: null }
  },
  data () {
    return {
      isEditing: false,
      hover: false,
      localLabels: [],
      newLabel: '',
      labelEditableID: null,
      responseLabels: [],
      labelsAvailableList: [],
      labelsItemHeight: '30px'
    }
  },
  mounted () {
    if (this.labels !== null) {
      this.localLabels = [...this.labels.map((label) => {
        return { ...label, isDeleted: false }
      })]
    }
    this.labelEditableID = uuid.v4()
  },
  methods: {
    handleGlobalEditing () {
      this.handleEditing()
    },
    handleCancel () {
      this.localLabels = [...this.labels]
      this.isEditing = false
    },
    handleEditing () {
      this.isEditing = true
      this.labelsItemHeight = (this.$refs['ContextItemLabels'].offsetHeight + 2) + 'px'
      if (this.isEditing && this.algoliaSearchLabels !== null) {
        this.handleAlgoliaSearchLabels()
      }
      if (this.isEditing && this.labelsList != null) {
        this.responseLabels = [...this.labelsList]
      }
      this.$nextTick(() => {
        if (this.isEditable) {
          setTimeout(() => {
            this.$refs[this.labelEditableID].focus()
          }, 20)
        }
      })
    },
    handleSave () {
      const newLabels = [].concat(this.localLabels.filter(({ isDeleted }) => !isDeleted))
      this.$emit('handleSaveLabels', newLabels)
      this.isEditing = false
    },
    addNewLabel (text) {
      if (text.length > 0 && this.allowCustomLabels) {
        this.localLabels.push({ name: text })
        this.newLabel = ''
        if (this.isEditing && this.algoliaSearchLabels !== null) {
          this.handleAlgoliaSearchLabels()
          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs[this.labelEditableID].focus()
            }, 20)
            this.labelsItemHeight = (this.$refs['ContextItemLabels'].offsetHeight + 2) + 'px'
          })
        }
      }
    },
    removeLabel (index) {
      this.localLabels[index].isDeleted = true
      this.localLabels = [].concat(this.localLabels)
    },
    handleSelect (text) {
      this.localLabels.push({ name: text })
      this.newLabel = ''
      if (this.algoliaSearchLabels !== null) {
        this.handleAlgoliaSearchLabels()
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs[this.labelEditableID].focus()
          }, 20)
          this.labelsItemHeight = (this.$refs['ContextItemLabels'].offsetHeight + 2) + 'px'
        })
      }
    },
    searchInAvailableLabels () {
      if (this.algoliaSearchLabels !== null) {
        this.handleAlgoliaSearchLabels(this.newLabel)
      }
    },
    handleAlgoliaSearchLabels (input = '') {
      algoliaService.getAllFacetsForAttribute(this.algoliaSearchLabels.index, ['labels'], input).then((response) => {
        this.responseLabels = response
      })
    }
  },
  computed: {
    actions: function () {
      if (!this.isEditing) {
        return [
          {
            icon: 'edit',
            tooltip: this.$i18n.t('buttons.edit'),
            callback: this.handleEditing
          }
        ]
      } else {
        return [
          {
            icon: 'fas fa-times',
            tooltip: this.$i18n.t('buttons.cancel'),
            callback: this.handleCancel
          },
          {
            icon: 'fas fa-save',
            tooltip: this.$i18n.t('buttons.save'),
            callback: this.handleSave
          }
        ]
      }
    }
  },
  watch: {
    responseLabels: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        let userCustomLabel = []
        if (this.newLabel.length > 0) {
          userCustomLabel.push(this.newLabel)
        }
        const existingLabels = [...val]

        this.labelsAvailableList = [].concat(existingLabels, userCustomLabel).filter((filterLabel) => {
          return this.localLabels.findIndex(({ name }) => {
            return name.toLowerCase() === filterLabel.toLowerCase()
          }) < 0
        }).map((mapLabel) => {
          return { text: mapLabel }
        })
      }
    },
    labels: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (val !== null) {
          this.localLabels = [...val.map((label) => {
            return { ...label, isDeleted: false }
          })]
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.context--item--labels--wrapper {
  position: relative;
  border-radius: 5px;
  width: 100%;
  .labels--list {
    background-color: white;
    width: 100%;
    // max-height: 75px;
    overflow-y: auto;
    border-radius: 5px;
    border: 2px solid #767676;
    padding: 0 5px;
    ul {
      list-style-type: none;
      padding: 0;
      li {
        cursor: pointer;
        color: #767676;
        font-size: 13px;
        font-weight: bold;
        margin-bottom: 5px;
        padding-left: 10px;
        border-radius: 5px;
        width: 100%;
        height: 100%;
        z-index: 9;
        &:hover {
          background-color: #f2f2f2;
        }
      }
    }
    z-index: 8;
    position: absolute;
    top: 30px;
    left: 0;
    &.bottom {
      &.list--height--1 {
        top: -120%;
      }
      &.list--height--2 {
        top: -200%;
      }
      top: -300%;
    }
  }
  &.hovered {
     background-color: #f2f2f2;
  }
  &.hover {
    background-color: #f2f2f2;
  }
  .context--item--labels--container {
    position: relative;
    padding-left: 5px;
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: left;
    justify-content: flex-start;
    border: 2px solid transparent;
    border-radius: 5px;
    margin-bottom: 1px;
    .context--label--edit__wrapper {
      .context--label--edit__input {
        width: 100%;
        position: relative;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        border-radius: 0;
        -moz-border-radius: 0;
        -webkit-border-radius: 0;
        outline: none;
        border: none;
        background-color: transparent;
        color: inherit;
        font-family: inherit;
        color: #484848;
        font-weight: 500;
        font-size: 13px;
        width: inherit;
      }
    }
    &.editing {
      border-color: #767676;
    }
    .icon {
      padding-top: 2px;
      i {
        color: #767676;
        font-size: 16px;
      }
      flex: 1 1 25%;
      &.empty--labels {
        margin-right: 3px;
      }
      margin-right: 15px;
      max-width: 16px;
    }
    .context--label__items {
      flex: 1 1 80%;
      max-width: 80%;
      display: flex;
      flex-direction: row;
      align-content: flex-start;
      flex-wrap: wrap;
      div {
        &.empty--labels {
          font-size: 13px;
          font-weight: bold;
          flex: 1 1 max-content;
          padding: 2px 0 0 0;
          margin-left: 5px;
        }
        margin-right: 2px;
        margin-top: 2px;
        margin-bottom: 2px;
        padding: 1px 9px;
        border: 0px solid;
        border-radius: 20px;
        // width: 100px;
        display: flex;
        align-content: flex-start;
        flex-wrap: nowrap;
        flex-direction: row;
        align-items: left;
        justify-content: flex-start;
        .label--name {
          color: white;
          font-weight: 500;
          flex: 1 1 auto;
          text-align: center;
          font-size: 13px;
          min-width: 21px;
        }
        .label--delete {
            flex: 1 1 auto;
            // width: 40px;
            text-align: center;
            font-size: 12px;
            font-weight: 500;
            color: white;
            padding-left: 5px;
            padding-top: 1px;
        }
      }
    }
    .editable--value {
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      border-radius: 0;
      -moz-border-radius: 0;
      -webkit-border-radius: 0;
      outline: none;
      border: none;
      background-color: transparent;
      color: inherit;
      font-family: inherit;
      color: #767676;
      &::placeholder {
        color: #48484880
      }
      font-weight: bold;
      font-size: 13px;
      width: 100%;
    }
  }
  .actions--panel {
    position: absolute;
    right: 3px;
    top: 2px;
    z-index: 9;
    background-color: #f2f2f2;
    height: calc(100% - 5px);
    display: flex;
    border-left: 1px solid #ededed;

    .icon-action {
      position: relative;
      top: 0;
      width: 20px;
      height: 20px;
      text-align: center;
      border-radius: 5px;
      i {
        color: #767676;
        font-size: 18px;
      }
      &:hover {
        background-color: #e0e0e0;
      }
    }
  }
  .icon-xl {
    vertical-align: middle;
    width: 17px;
    height: 17px;
    font-size: 17px;
  }
  .icon-lg-down {
    vertical-align: middle;
    width: 15px;
    height: 15px;
    font-size: 15px;
  }
  .text-text {
    font-size: 17px;
  }
  .text-lg-down {
    font-size: 15px;
  }
}
</style>
